<div class="flex flex-col items-start justify-between" *transloco="let t">
  <div class="flex w-full flex-col items-start justify-start">
    <app-product-view
      [asin]="modalData.asin"
      [marketplace]="modalData.marketplace"
      class="mb-4 w-full rounded-lg border border-solid border-gray-300 p-4"
    ></app-product-view>
    <div class="w-full">
      <IFormField>
        <label iLabel>{{ t("cogs-upload-modal.cost_of_goods", [currencySymbol]) }}</label>
        <input
          iInput
          class="w-full"
          [min]="0"
          [(ngModel)]="cogValue"
          placeholder="{{ t('cogs-upload-modal.enter_cost', [currencySymbol]) }}"
          type="decimal"
          [maxLength]="10"
        />
      </IFormField>
    </div>
  </div>
  <div class="mt-4 flex w-full justify-between">
    <button iButton variant="secondary" size="sm" (click)="closeModal()">{{ t("common.cancel") }}</button>

    <div class="flex gap-2">
      <button
        iButton
        [iTooltip]="t('cogs-upload-modal.delete_cost_goods_tooltip')"
        variant="destructive"
        [disabled]="!cogValue()"
        size="sm"
        (click)="deleteCostOfGood()"
      >
        {{ t("common.delete") }}
      </button>
      <button iButton [disabled]="!cogValue()" (click)="updateCostOfGood(cogValue()!)" size="sm">
        {{ t("common.update") }}
      </button>
    </div>
  </div>
</div>
